/* ============================================================
   tio-home.js — carruseles del Home.

   El gesto TACTIL no se toca: es scroll-snap nativo del navegador
   (60fps, inercia de iOS). Cero JS en el touch, y por eso nunca se come
   un tap sobre "Agregar" ni sobre la card.

   El JS solo agrega lo que el navegador no da:
     - flechas de desktop y contador "n / total"
     - arrastre con MOUSE, con inercia al soltar

   Doctrina 8.1: listeners DELEGADOS en document. Las cards se
   re-renderizan y el editor de temas re-monta secciones enteras.
   ============================================================ */
(function () {
  'use strict';

  var DUR = 420;

  function pista(rail) { return rail.querySelector('[data-tio-rail-pista]'); }

  /* Indice de la tarjeta mas cercana al borde izquierdo del scroll. */
  function indiceActual(el) {
    var hijos = el.children;
    if (!hijos.length) return 0;
    var base = hijos[0].offsetLeft;
    var mejor = 0;
    var mejorD = Infinity;
    for (var i = 0; i < hijos.length; i++) {
      var d = Math.abs((hijos[i].offsetLeft - base) - el.scrollLeft);
      if (d < mejorD) { mejorD = d; mejor = i; }
    }
    return mejor;
  }

  function pintarContador(rail) {
    var el = pista(rail);
    if (!el) return;
    var i = indiceActual(el);
    var total = el.children.length;

    var num = rail.querySelector('[data-tio-rail-actual]');
    if (num) num.textContent = i + 1;

    var prevs = rail.querySelectorAll('.home-railbar__btn[data-tio-rail-prev]');
    var nexts = rail.querySelectorAll('.home-railbar__btn[data-tio-rail-next]');
    for (var a = 0; a < prevs.length; a++) prevs[a].disabled = i === 0;
    for (var b = 0; b < nexts.length; b++) nexts[b].disabled = i >= total - 1;
  }

  /* Animacion por setInterval, no requestAnimationFrame: rAF se estrangula
     dentro de iframes (el editor de temas es uno) y dejaba las flechas sin
     mover. No se toca scroll-snap-type: el destino ES un punto de snap. */
  var animaciones = new WeakMap();

  function animarHasta(el, destino) {
    clearInterval(animaciones.get(el));
    var max = el.scrollWidth - el.clientWidth;
    var fin = Math.max(0, Math.min(max, destino));
    var ini = el.scrollLeft;
    var dist = fin - ini;
    if (Math.abs(dist) < 1) return;
    var t0 = Date.now();
    var id = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / DUR);
      el.scrollLeft = ini + dist * (1 - Math.pow(1 - p, 3));
      if (p >= 1) clearInterval(id);
    }, 16);
    animaciones.set(el, id);
  }

  function irA(rail, i) {
    var el = pista(rail);
    if (!el || !el.children.length) return;
    var n = Math.max(0, Math.min(el.children.length - 1, i));
    var base = el.children[0].offsetLeft;
    animarHasta(el, el.children[n].offsetLeft - base);
  }

  /* ---------------- Flechas (delegado) ---------------- */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-tio-rail-prev]');
    var next = e.target.closest('[data-tio-rail-next]');
    if (!prev && !next) return;
    var rail = (prev || next).closest('[data-tio-rail]');
    if (!rail) return;
    var el = pista(rail);
    if (!el) return;
    irA(rail, indiceActual(el) + (next ? 1 : -1));
  });

  /* ---------------- Contador (listener pasivo) ---------------- */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el.hasAttribute || !el.hasAttribute('data-tio-rail-pista')) return;
    var rail = el.closest('[data-tio-rail]');
    if (rail) pintarContador(rail);
  }, true);

  /* ---------------- Arrastre con MOUSE ----------------
     Solo mouse. El tactil sigue 100% nativo. El clic se suprime unicamente
     si hubo arrastre real (>6px), para no romper "Agregar" ni el enlace a
     la PDP en un clic normal. */
  var arrastre = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    var el = e.target.closest('[data-tio-rail-pista]');
    if (!el) return;
    clearInterval(animaciones.get(el));
    arrastre = { el: el, x: e.clientX, left: el.scrollLeft, movido: false, ultX: e.clientX, ultT: Date.now(), v: 0 };
  });

  document.addEventListener('pointermove', function (e) {
    if (!arrastre) return;
    var dx = e.clientX - arrastre.x;
    if (!arrastre.movido && Math.abs(dx) > 6) {
      arrastre.movido = true;
      arrastre.el.style.scrollSnapType = 'none';
      arrastre.el.classList.add('is-dragging');
    }
    if (arrastre.movido) {
      arrastre.el.scrollLeft = arrastre.left - dx;
      var ahora = Date.now();
      var dt = ahora - arrastre.ultT;
      if (dt > 0) arrastre.v = (e.clientX - arrastre.ultX) / dt;
      arrastre.ultX = e.clientX;
      arrastre.ultT = ahora;
    }
  });

  function soltar() {
    if (!arrastre) return;
    var a = arrastre;
    arrastre = null;
    if (!a.movido) return;

    /* Proyeccion por inercia: no corta en seco, sigue flotando hasta la
       tarjeta que corresponde al impulso. */
    var el = a.el;
    var proyectado = el.scrollLeft - a.v * 180;
    var hijos = el.children;
    var base = hijos.length ? hijos[0].offsetLeft : 0;
    var mejor = 0;
    var mejorD = Infinity;
    for (var i = 0; i < hijos.length; i++) {
      var d = Math.abs((hijos[i].offsetLeft - base) - proyectado);
      if (d < mejorD) { mejorD = d; mejor = i; }
    }
    animarHasta(el, hijos.length ? hijos[mejor].offsetLeft - base : 0);

    setTimeout(function () {
      el.style.scrollSnapType = '';
      el.classList.remove('is-dragging');
    }, DUR);

    /* Suprime SOLO el clic que cierra este arrastre. */
    var tragar = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
    el.addEventListener('click', tragar, { capture: true, once: true });
    setTimeout(function () { el.removeEventListener('click', tragar, { capture: true }); }, 0);
  }

  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);

  function iniciar() {
    var rails = document.querySelectorAll('[data-tio-rail]');
    for (var i = 0; i < rails.length; i++) pintarContador(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  window.addEventListener('resize', iniciar);
  document.addEventListener('shopify:section:load', iniciar);
})();
